module.exports = __webpack_public_path__ + "img/zippo2.7a107eb1.webp";